import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ExternalLink, CheckCircle, DollarSign, Users, TrendingUp } from "lucide-react";

const NeobuxCadastroPage = () => {
  const handleCadastro = () => {
    window.open("https://www.neobux.com/?r=bow456", "_blank");
  };

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main className="container mx-auto px-4 py-8">
        <h1 className="text-4xl font-bold text-center mb-8">Cadastre-se no Neobux</h1>
        
        <div className="max-w-4xl mx-auto">
          <Card className="shadow-lg mb-8">
            <CardHeader className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white">
              <CardTitle className="text-3xl">Comece a Ganhar Dinheiro Online</CardTitle>
              <CardDescription className="text-white/90 text-lg">
                Junte-se a milhões de usuários que ganham dinheiro com o Neobux
              </CardDescription>
            </CardHeader>
            <CardContent className="p-8">
              <div className="grid gap-6 md:grid-cols-2">
                <div className="space-y-4">
                  <h3 className="text-xl font-semibold flex items-center">
                    <CheckCircle className="mr-2 h-5 w-5 text-green-500" />
                    Por que escolher o Neobux?
                  </h3>
                  <ul className="space-y-2 pl-7">
                    <li>Plataforma confiável desde 2008</li>
                    <li>Pagamentos pontuais e garantidos</li>
                    <li>Múltiplas formas de ganhar dinheiro</li>
                    <li>Comunidade ativa e suporte</li>
                    <li>Sem investimento inicial necessário</li>
                  </ul>
                </div>
                
                <div className="space-y-4">
                  <h3 className="text-xl font-semibold flex items-center">
                    <DollarSign className="mr-2 h-5 w-5 text-green-500" />
                    Como você ganha dinheiro
                  </h3>
                  <ul className="space-y-2 pl-7">
                    <li>Visualizando anúncios diariamente</li>
                    <li>Completando ofertas e pesquisas</li>
                    <li>Participando de promoções</li>
                    <li>Convidando amigos (sistema de referidos)</li>
                    <li>Alugando referidos para aumentar ganhos</li>
                  </ul>
                </div>
              </div>
              
              <div className="mt-8 text-center">
                <Button 
                  size="lg" 
                  className="bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 text-lg px-8 py-6 h-auto"
                  onClick={handleCadastro}
                >
                  Criar Conta Grátis no Neobux <ExternalLink className="ml-2 h-5 w-5" />
                </Button>
                <p className="mt-2 text-sm text-muted-foreground">
                  Cadastro 100% gratuito e sem compromisso
                </p>
              </div>
            </CardContent>
          </Card>
          
          <div className="grid gap-6 md:grid-cols-3 mb-8">
            <Card className="shadow-md">
              <CardHeader>
                <CardTitle className="flex items-center">
                  <DollarSign className="mr-2 h-5 w-5 text-blue-500" />
                  Ganhos Diários
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p>
                  Clique em anúncios diariamente e ganhe entre $0.001 e $0.02 por clique. 
                  Com estratégia, seus ganhos aumentam significativamente ao longo do tempo.
                </p>
              </CardContent>
            </Card>
            
            <Card className="shadow-md">
              <CardHeader>
                <CardTitle className="flex items-center">
                  <Users className="mr-2 h-5 w-5 text-blue-500" />
                  Sistema de Referidos
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p>
                  Ganhe comissões dos cliques de seus referidos. Você pode convidar amigos 
                  ou alugar referidos diretamente na plataforma.
                </p>
              </CardContent>
            </Card>
            
            <Card className="shadow-md">
              <CardHeader>
                <CardTitle className="flex items-center">
                  <TrendingUp className="mr-2 h-5 w-5 text-blue-500" />
                  Crescimento Contínuo
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p>
                  Reinvista seus ganhos em referidos alugados para criar um sistema de 
                  renda passiva que cresce com o tempo.
                </p>
              </CardContent>
            </Card>
          </div>
          
          <Card className="shadow-lg">
            <CardHeader>
              <CardTitle className="text-2xl">Dicas para Maximizar seus Ganhos</CardTitle>
            </CardHeader>
            <CardContent className="p-6">
              <ul className="space-y-3">
                <li className="flex items-start">
                  <span className="font-bold mr-2">1.</span>
                  <span>Clique em todos os anúncios disponíveis todos os dias sem falhar</span>
                </li>
                <li className="flex items-start">
                  <span className="font-bold mr-2">2.</span>
                  <span>Reinvista seus ganhos em referidos alugados para multiplicar sua renda</span>
                </li>
                <li className="flex items-start">
                  <span className="font-bold mr-2">3.</span>
                  <span>Participe das pesquisas para ganhar valores maiores ($0.01 a $0.21)</span>
                </li>
                <li className="flex items-start">
                  <span className="font-bold mr-2">4.</span>
                  <span>Utilize nossas estratégias exclusivas para otimizar seus ganhos</span>
                </li>
                <li className="flex items-start">
                  <span className="font-bold mr-2">5.</span>
                  <span>Seja paciente e consistente - resultados significativos vêm com o tempo</span>
                </li>
              </ul>
              
              <div className="mt-6 flex justify-center">
                <Button 
                  variant="outline" 
                  className="mr-4"
                  onClick={() => window.location.href = "/neobux-estrategia"}
                >
                  Ver Estratégias Avançadas
                </Button>
                <Button onClick={handleCadastro}>
                  Criar Conta Agora <ExternalLink className="ml-2 h-4 w-4" />
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NeobuxCadastroPage;